import { Injectable } from '@angular/core';
import { WindowService } from '@ups/xplat/core';

@Injectable({
  providedIn: 'root',
})
export class AppFlagService {
  constructor(private win: WindowService) {}

  _getPlatform() {
    return /Android/i.test(this.win.navigator.userAgent) ? 'android' : 'ios';
  }
}
